import { axios } from '../http-common';

class Member {
  domain(){
    return axios.get("v1/member/profile/domain");
  }
  userListDebug(){
    return axios.get("v1/member/maintenance/partner");
  }
}

export default new Member();